// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1xVE6","title":"Images90_title__eOwXu","images":"Images90_images__2TFzS"};